import { Box, Typography, IconButton } from "@mui/joy";
import { Minus, Plus } from "lucide-react";
import { measurementGroups, getMeasurementIcon } from "./types";

export function DesktopView({ measurementData, handleMeasurementUpdate }: any) {
    const renderDesktopMeasurementItem = (item: any) => (
        <Box
            key={item.name}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 1.5,
                bgcolor: "background.surface",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "sm",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, pr: 1 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "sm",
                        bgcolor: "background.level1",
                        color: "text.tertiary",
                        flexShrink: 0,
                    }}
                >
                    {getMeasurementIcon(item.name)}
                </Box>
                <Typography level="body-sm" sx={{ fontWeight: "md", color: "text.primary" }} noWrap>
                    {item.name}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    bgcolor: "background.level1",
                    borderRadius: "32px",
                    p: 0.5,
                }}
            >
                <IconButton
                    variant="plain"
                    color="neutral"
                    size="sm"
                    onClick={() => handleMeasurementUpdate("remove", item)}
                    disabled={!item.actual || item.actual === 0}
                    sx={{ borderRadius: "50%", "--IconButton-size": "28px" }}
                >
                    <Minus size={14} />
                </IconButton>
                <Typography level="title-sm" sx={{ minWidth: "24px", textAlign: "center", fontWeight: "lg" }}>
                    {item.actual || 0}
                </Typography>
                <IconButton
                    variant="plain"
                    color="neutral"
                    size="sm"
                    onClick={() => handleMeasurementUpdate("add", item)}
                    sx={{ borderRadius: "50%", "--IconButton-size": "28px", bgcolor: "background.surface" }}
                >
                    <Plus size={14} />
                </IconButton>
            </Box>
        </Box>
    );

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {Object.entries(measurementGroups).map(([groupName, groupItems]) => {
                const itemsInGroup = measurementData.filter((item: any) => groupItems.includes(item.name));
                if (itemsInGroup.length === 0) return null;

                return (
                    <Box key={groupName} sx={{ mb: 3 }}>
                        <Typography level="title-md" sx={{ fontWeight: "xl", mb: 1.5, color: "text.primary" }}>
                            {groupName}
                        </Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                                gap: 1.5,
                            }}
                        >
                            {itemsInGroup.map((item: any) => renderDesktopMeasurementItem(item))}
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}
